import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PermissionGuardGuard implements CanActivateChild {
  constructor(private router: Router) { }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const menus = JSON.parse(localStorage.getItem('menus') || '[]');
    const currentUrl = state.url;

    if (currentUrl == '/app/employee/employee-dashboard' || currentUrl.startsWith('/app/employee/list/profile-info') || currentUrl == '/app/employee/profile-info') {
      return true;
    }
    const matchedMenu = menus.find((m: any) => currentUrl.startsWith(m.link));

    if (!matchedMenu) {
      return true;
    }
    if (!matchedMenu || !matchedMenu.can_view) {
      this.router.navigate(['/403']);
      return false;
    }

    return true;
  }
}
